import React from "react";
import PropTypes from "prop-types";
import CardClass from "../../../CardClass";
import MUIGrid from "@mui/material/Grid";
import MUITextField from "@mui/material/TextField";
import MUIAutocomplete from "@mui/material/Autocomplete";
import Term from "../../../../Utility/Crud/Term";
import MainContext from "../../../../Context/MainContext/MainContext";
export default class CardAdminDistributionReasonGeneral extends CardClass {
  static contextType = MainContext; // For legacy class components

  /**
   * Render the content of the card.
   */
  renderContent() {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} sm={6} md={3}>
          <MUITextField
            value={
              this.props.distributionReason
                ? this.props.distributionReason.code
                : ""
            }
            autoFocus={true}
            size="small"
            label="Code"
            variant="standard"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => this.props.onChange({ code: e.target.value.trim() })}
            onChange={(e) => this.props.onChange({ code: e.target.value })}
            required={true}
            error={this.props.validationIssues.code ? true : false}
            helperText={
              this.props.validationIssues.code
                ? this.props.validationIssues.code
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={12}>
          <MUITextField
            value={
              this.props.distributionReason
                ? this.props.distributionReason.description
                : ""
            }
            size="small"
            label="Description"
            variant="standard"
            fullWidth={true}
            inputProps={{
              maxLength: 1024,
            }}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) =>
              this.props.onChange({ description: e.target.value.trim() })
            }
            onChange={(e) =>
              this.props.onChange({ description: e.target.value })
            }
          />
        </MUIGrid>

        <MUIGrid item xs={12} sm={4}>
          <MUIAutocomplete
            options={Term.sort(
              Term.read(this.context.termsIndexed, [
                { key: "type", value: "distribution_reason_type" },
              ]),
            )}
            getOptionLabel={Term.getDisplayName}
            isOptionEqualToValue={(option, value) => {
              return option.id === value?.id;
            }}
            value={
              this.props.distributionReason?.distributionReasonTypeTermId
                ? this.context.termsIndexed[
                    this.props.distributionReason.distributionReasonTypeTermId
                  ]
                : null
            }
            onChange={(e, term) =>
              this.props.onChange({
                distributionReasonTypeTermId: term?.id || null,
              })
            }
            clearOnBlur
            renderInput={(params) => (
              <MUITextField
                {...params}
                InputLabelProps={{ shrink: true }}
                size="small"
                label="Distribution Reason Type"
                variant="standard"
                fullWidth
                required
                error={
                  !!this.props.validationIssues.distributionReasonTypeTermId
                }
                helperText={
                  this.props.validationIssues.distributionReasonTypeTermId
                }
              />
            )}
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
